import axios from 'axios';
import { PaginatedProducts } from '../types';

export const fetchProductList = async (): Promise<PaginatedProducts> => {
  return (await axios.get(`/v1/product`)).data;
};
